import { render, staticRenderFns } from "./ProductOsRelate.vue?vue&type=template&id=d1138a96"
import script from "./ProductOsRelate.vue?vue&type=script&lang=js"
export * from "./ProductOsRelate.vue?vue&type=script&lang=js"
import style0 from "./ProductOsRelate.vue?vue&type=style&index=0&id=d1138a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports